import styled from 'styled-components';
import SummaryTitleTemplate from './SummaryTitleTemplate';
import { rem } from 'polished';

export const SummaryTitleStyled = styled(SummaryTitleTemplate)`
    margin: ${rem(24)} ${rem(10)} ${rem(32)} ${rem(10)};

    h3 {
        font-size: ${rem(30)};
        line-height: 1.2;
    }

    p {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        line-height: 1.4;
    }
`;
